const OTC_COMMAND_PKG = {
    navTitle: "OTC",
    routerName: "OTCDocs",
    commandsDescription: "Top OTC, Weekly, Daily, etc...",

    commandList: [
        {
            title: "OTC 5m",
            routerRef: "chartotc_5m",
            commandString: "!chartotc_5m <stock>",
            description: "5m OTC Chart",
            parameters:[
                { name: "Symbol: ", desc: "The symbol/ticker of the OTC stock" }
            ],
            examples: [
                "!chartotc_5m axpw"
            ],
            type: "OTC", 
            shortcuts: ["!c5otc"]
        },
        {
            title: "OTC Daily",
            routerRef: "chartotc_d",
            commandString: "!chartotc_d <stock>",
            description: "Daily OTC Chart",
            parameters:[
                { name: "Symbol: ", desc: "The symbol/ticker of the OTC stock" }
            ],
            examples: [
                "!chartotc_d axpw"
            ],
            type: "OTC", 
            shortcuts: ["!cdotc"]
        },
        {
            title: "OTC Weekly",
            routerRef: "chartotc_w",
            commandString: "!chartotc_w <stock>",
            description: "Weekly OTC Chart",
            parameters:[
                { name: "Symbol: ", desc: "The symbol/ticker of the OTC stock" }
            ],
            examples: [
                "!chartotc_w axpw"
            ],
            type: "OTC", 
            shortcuts: ["!cwotc"]
        },
/*        {
            title: "OTC Stock Info",
            routerRef: "otc",
            commandString: "!otc <stock>",
            description: "Gives information on OTC stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the OTC stock" }
            ],
            examples: [
                "!otc axpw"
            ],
            type: "OTC", 
            shortcuts: ["none"]
        },
        {
            title: "OTC Stock Price",
            routerRef: "otcprice",
            commandString: "!otcprice <stock>",
            description: "Gives price information on otc stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the OTC stock" }
            ],
            examples: [
                "!otcprice axpw"
            ],
            type: "OTC", 
            shortcuts: ["none"]
        },
        {
            title: "Top OTC Volume",
            routerRef: "otcvol",
            commandString: "!otcvol",
            description: "Top 10 OTC stocks by volume",
            parameters: ["none"],
            examples: [
                "!otcvol"
            ],
            type: "OTC", 
            shortcuts: ["none"]
        },*/
    ]
}


export {OTC_COMMAND_PKG};